export default [
  {
    name: 'wallet',
    path: '/wallet',
    component: () => import('views/wallet/wallet.vue'),
    meta: {
      needToken: true,
    },
  },
  {
    name: 'walletDetail',
    path: '/wallet-detail',
    component: () => import('views/wallet/wallet-detail.vue'),
    meta: {
      needToken: true,
    },
  },
  {
    name: 'bankCard',
    path: '/bank-card',
    component: () => import('views/wallet/bank-card.vue'),
    meta: {
      needToken: true
    }
  },
  {
    name: 'addBankCard',
    path: '/add-bank-card',
    component: () => import('views/wallet/add-bank-card.vue'),
    meta: {
      needToken: true
    }
  }
];
